import { useTranslation } from "../../../i18n";
import "../../../styles/gamification.css";

interface TimeBonusPopupProps {
    seconds: number | null;
    color: "green" | "amber";
    streak: number;
    isBest: boolean;
    bumpKey: number;
    /** When the surrounding background is dark, flip the streak label to white
     *  so it stays legible. Default false keeps the original dark-text look on
     *  the sorter's neutral background. */
    darkBackground?: boolean;
}

const TimeBonusPopup = ({ seconds, color, streak, isBest, bumpKey, darkBackground = false }: TimeBonusPopupProps) => {
    const { t } = useTranslation();
    if (seconds === null) return null;
    return (
        <div className={`s2-time-bonus s2-time-bonus-${color} ${darkBackground ? "s2-time-bonus-light" : ""}`} key={bumpKey}>
            +{seconds}s
            {(streak > 1 || isBest) && (
                <span className="s2-streak-row">
                    {streak > 1 && <span className="s2-streak">{t("streak")} {streak}x</span>}
                    {isBest && <span className="s2-best-badge">{t("best_time")}</span>}
                </span>
            )}
        </div>
    );
};

export default TimeBonusPopup;
